import download from 'downloadjs';
import * as XLSX from 'xlsx';

const XLSX_MIME =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export type DownloadWorkbookXlsxOptions = {
    workbook: XLSX.WorkBook;
    filename: string;
};

export const downloadWorkbookXlsx = ({
    workbook,
    filename,
}: DownloadWorkbookXlsxOptions): void => {
    const xlsxOutput = XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
    });
    const xlsxBlob = new Blob([xlsxOutput], { type: XLSX_MIME });

    if (typeof window !== 'undefined' && (window as any).Cypress) {
        (window as any).__penamLastExportWorkbook = workbook;
        (window as any).__penamLastExportFilename = filename;
    }

    download(xlsxBlob, filename, XLSX_MIME);
};
